import { render, staticRenderFns } from "./stock-status-report.vue?vue&type=template&id=4d796978&"
import script from "./js/stock-status-report.js?vue&type=script&lang=js&"
export * from "./js/stock-status-report.js?vue&type=script&lang=js&"
import style0 from "./stock-status-report.vue?vue&type=style&index=0&id=4d796978&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports